function HandleAsyncError() {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor | any) => {
    const originalMethod = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      try {
        return await originalMethod.apply(this, args);
      } catch (error) {
        // const errorContent = `${error.name}\n${error.message}.\n${error.stack}`;
        this.metricsService.endpointError();
      }
    };

    return descriptor;
  };
}

export default HandleAsyncError;
